module.exports = __webpack_public_path__ + "static/media/blur.0ab1507c.svg";